import { HYDRATE_USER } from 'config/actionTypes';

export const hydrateUserAction: ActionTypes.User.HydrateUserAction = (payload) => {
  return { type: HYDRATE_USER, payload };
};
